




























import mixins from 'vue-typed-mixins';
import E2EMixin from '@/components/mixins/E2EMixin';
import { isNullOrUndefinedOrEmpty } from '@/utils/boolean';
import { ValidationProvider } from 'vee-validate';
import { PropType } from 'vue';
import { ValidatorProps } from 'types/validator';

export default mixins(E2EMixin).extend({
  components: {
    ValidationProvider,
  },
  props: {
    name: {
      type: String,
      default: '',
    },
    value: {
      type: [Number],
      default: null,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 10,
    },
    validator: {
      type: Object as PropType<ValidatorProps>,
      default: () => ({ name: undefined, rules: undefined }),
    },
  },
  data() {
    let innerValue = this.value;
    // set default value
    if (isNullOrUndefinedOrEmpty(innerValue)) {
      innerValue = 5;
      this.$emit('input', innerValue);
    }
    return {
      innerValue,
    };
  },
  computed: {
    color: () => '#ea5514',
  },
  watch: {
    innerValue(val) {
      this.$emit('input', val);
    },
  },
});
